// extracted by mini-css-extract-plugin
export default {"field":"CardMoveStep_field__HnpJW","text":"CardMoveStep_text__AwHbK"};